module.exports = __webpack_public_path__ + "static/media/upload-file-button.ef0acb93.svg";